module.exports = __webpack_public_path__ + "media/images/flags/64/Pitcairn-Islands-810d8db3a22dfca7eb8c6a9bb7c13d1f.png";